import { Box, Drawer, Typography } from "@mui/material";
import React from "react";
import { Link, useNavigate } from "react-router-dom";

import { LOGO } from "constant/projectConstant";
import { path } from "constant/pathLinksConstant";
import AppetiteStepper from "components/CustomStepper/appetiteStepper";
import ProfileSection from "components/ProfileSection/ProfileSection";
import { useAuth } from "hooks/useAuth";
import { ZOHO_CHAT_KEY } from "constant/apiConstant";

import logo from "../../assets/logo.svg";
import exit from "../../assets/icons/exit.svg";

// Drawer styles
const drawerStyle = {
  width: { sm: 240, md: 240 },
  backgroundColor: "white",
  flexShrink: 0,
  "& .MuiDrawer-paper": {
    width: { sm: 240, md: 240 },
    padding: "24px",
    boxSizing: "border-box",
    borderRadius: "0 4px 4px 0"
  }
};

const logoStyle = {
  width: "7.5rem",
  height: "2.06144rem"
};

const steps = [
  {
    title: "Check Appetite",
    subSteps: [
      {
        name: "Industry",
        index: 0,
        slug: ["SelectCarrier", "ProductList"]
      },
      {
        name: "Eligibility",
        index: 1,
        slug: ["CheckEligibility"]
      }
    ]
  },
  {
    title: "Start Application",
    subSteps: []
  },
  {
    title: "Data Collection",
    subSteps: []
  },
  {
    title: "Underwriting",
    subSteps: []
  }
];

const NewApplicationSidebar = ({ children, applicationProgress }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  // Function to initialize Microsoft Chat Widget
  const openChatHandler = () => {
    if (!document.getElementById("zsiqscript")) {
      // Initialize Zoho SalesIQ object
      window.$zoho = window.$zoho || {};
      window.$zoho.salesiq = window.$zoho.salesiq || {};

      // Add ready function to handle the chat visibility
      window.$zoho.salesiq.ready = function () {
        if (window.$zoho.salesiq && window.$zoho.salesiq.floatwindow) {
          window.$zoho.salesiq.floatwindow.visible("show");
        }
      };

      // Dynamically load the Zoho SalesIQ script
      const script = document.createElement("script");
      script.id = "zsiqscript";
      script.src = `https://salesiq.zohopublic.com/widget?wc=${ZOHO_CHAT_KEY}`;
      script.defer = true;

      document.body.appendChild(script);
    } else {
      const element = document.querySelector('[data-id="zsalesiq"]');
      // If script is already loaded, check and open the chat directly
      if (window.$zoho && window.$zoho.salesiq) {
        if (element) {
          element.style.display = "block";
          window.$zoho.salesiq.floatwindow.visible("show");
        }
      }
    }
  };

  const sendEmailHandler = () => {
    window.location.href = "mailto:underwriting@squarerisk.com";
  };


  const handleExit = () => {
    if (user) {
      const element = document.querySelector('[data-id="zsalesiq"]');
      if (element) {
        element.style.display = "none";
      }
      navigate(path.applications.root);
    } else {
      // Navigate to the login page if user is not defined
      navigate(path.app.login);
    }
  };

  return (
    <Box className="w-full flex justify-start overflow-x-hidden">
      <Drawer sx={drawerStyle} variant="permanent" anchor="left">
        <Link to="/" className="w-full flex justify-center">
          <img src={logo} alt={LOGO} style={{ ...logoStyle }} />
        </Link>

        <ProfileSection
          sendEmailHandler={sendEmailHandler}
          openChatHandler={openChatHandler}
        />

        <Box className="w-full bg-[#F9FAFB] p-2 rounded-[4px] mt-4">
          <Typography
            sx={{ fontSize: "14px", fontWeight: 500 }}
            className="text-[14px] font-[500] my-2"
          >
            Application Progress: {applicationProgress}%
          </Typography>
          <Box className="w-11/12  bg-[#eceff2] h-2 rounded-[28px]">
            <Box
              sx={{ width: `${applicationProgress}%` }}
              className=" bg-[#1E9D66] h-2 rounded-[28px]"
            ></Box>
          </Box>
        </Box>

        <AppetiteStepper
          steps={steps}
          applicationProgress={applicationProgress}
        />
      </Drawer>
      <Box className="w-full max-w-[calc(100%-240px)] ">
        <Box className="w-full flex justify-end p-3 border-b borber-b-[#E2E5E9] bg-white h-16">
          <Box
            onClick={handleExit}
            href="#"
            className="bg-[#D64550] py-[8px] gap-2 px-[16px] h-8 rounded-[8px] flex items-center cursor-pointer"
          >
            <div className="text-white text-[14px] font-[600]">Exit</div>
            <img src={exit} alt="" />
          </Box>
        </Box>
        {children}
      </Box>
    </Box>
  );
};

export default NewApplicationSidebar;
